import { createApiActionType, createActionType } from 'app/store/utils';
import {
    CANCEL_JOB_RUN,
    DELETE_JOB_DEFINITION,
    DELETE_JOB_ENVIRONMENT,
    DELETE_SNOWFLAKE_SERVICE_ACCOUNT_USER,
    GET_JOB_ACTIVITY_METRICS,
    GET_JOB_RUN,
    GET_JOB_RUN_FILTER_OPTIONS,
    GET_JOB_RUN_TIMELINE,
    GET_LAST_JOB_RUN,
    GET_PROJECTS_CONTAINING_TABLE_DEPLOYMENTS,
    GET_SNOWFLAKE_STAGE_DETAILS,
    GET_SNOWFLAKE_STAGE_FILE_INFO,
    LIST_JOB_DEFINITIONS,
    LIST_JOB_ENVIRONMENTS,
    LIST_JOB_RUNS,
    LIST_SNOWFLAKE_FILE_FORMATS,
    LIST_SNOWFLAKE_SERVICE_ACCOUNT_USERS,
    LIST_SNOWFLAKE_STAGES,
    LIST_SNOWFLAKE_STAGE_FILES,
    PAUSE_JOB_TRIGGER,
    RESUME_JOB_TRIGGER,
    SET_JOB_DEFINITION,
    SET_JOB_ENVIRONMENT,
    SET_SNOWFLAKE_SERVICE_ACCOUNT_USER,
    TRIGGER_JOB_RUN,
    TRIGGER_JOB_RUNS,
    LIST_SNOWFLAKE_STORED_PROCEDURES,
    AUDIT_JOB_RUN,
    GET_JOB_OPERATION_COUNTS,
    GET_MODEL_TAG_CHECK_CANDIDATES,
    GET_JOB_DEFINITION,
    GET_MODEL_TAG_SOURCE_TABLES
} from 'app/lib/types/server';

const apiType = createApiActionType('jobs');
const type = createActionType('jobs');

export const GET_STORED_PROCEDURE_AUDIT_DATA_ACTION_TYPE = apiType(AUDIT_JOB_RUN);
export const GET_PROJECTS_CONTAINING_TABLE_DEPLOYMENTS_ACTION_TYPE = apiType(
    GET_PROJECTS_CONTAINING_TABLE_DEPLOYMENTS
);
export const GET_JOB_ACTIVITY_METRICS_ACTION_TYPE = apiType(GET_JOB_ACTIVITY_METRICS);
export const GET_JOB_OPERATION_COUNTS_ACTION_TYPE = apiType(GET_JOB_OPERATION_COUNTS);
export const LIST_JOB_ENVIRONMENTS_ACTION_TYPE = apiType(LIST_JOB_ENVIRONMENTS);
export const GET_JOB_RUN_FILTER_OPTIONS_ACTION_TYPE = apiType(GET_JOB_RUN_FILTER_OPTIONS);
export const LIST_JOB_DEFINITIONS_ACTION_TYPE = apiType(LIST_JOB_DEFINITIONS);
export const LIST_STORED_PROCEDURE_CANDIDATES_ACTION_TYPE = apiType(
    LIST_SNOWFLAKE_STORED_PROCEDURES
);
export const GET_JOB_TRIGGER_CANDIDATES_BY_ROLE_ACTION_TYPE = apiType(
    'GetJobTriggerCandidatesByRole'
);

export const LIST_JOB_RUNS_ACTION_TYPE = apiType(LIST_JOB_RUNS);
export const LIST_SNOWFLAKE_SERVICE_ACCOUNT_USERS_ACTION_TYPE = apiType(
    LIST_SNOWFLAKE_SERVICE_ACCOUNT_USERS
);
export const GET_JOB_RUN_ACTION_TYPE = apiType(GET_JOB_RUN);
export const CANCEL_JOB_RUN_ACTION_TYPE = apiType(CANCEL_JOB_RUN);
export const GET_JOB_RUN_TIMELINE_ACTION_TYPE = apiType(GET_JOB_RUN_TIMELINE);
export const GET_LAST_JOB_RUN_ACTION_TYPE = apiType(GET_LAST_JOB_RUN);

export const SET_JOB_ENVIRONMENT_ACTION_TYPE = apiType(SET_JOB_ENVIRONMENT);
export const SET_JOB_DEFINITION_ACTION_TYPE = apiType(SET_JOB_DEFINITION);
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_USER_ACTION_TYPE = apiType(
    SET_SNOWFLAKE_SERVICE_ACCOUNT_USER
);
export const DELETE_JOB_DEFINITION_ACTION_TYPE = apiType(DELETE_JOB_DEFINITION);
export const DELETE_JOB_ENVIRONMENT_ACTION_TYPE = apiType(DELETE_JOB_ENVIRONMENT);
export const PAUSE_JOB_TRIGGER_ACTION_TYPE = apiType(PAUSE_JOB_TRIGGER);
export const DELETE_SNOWFLAKE_SERVICE_ACCOUNT_USER_ACTION_TYPE = apiType(
    DELETE_SNOWFLAKE_SERVICE_ACCOUNT_USER
);
export const RESUME_JOB_TRIGGER_ACTION_TYPE = apiType(RESUME_JOB_TRIGGER);

export const TRIGGER_JOB_RUN_ACTION_TYPE = apiType(TRIGGER_JOB_RUN);
export const TRIGGER_JOB_RUNS_ACTION_TYPE = apiType(TRIGGER_JOB_RUNS);

export const RESET_SET_ENVIRONMENT_ACTION_TYPE = type('ResetSetEnvironment');
export const RESET_SET_JOB_DEFINITION_ACTION_TYPE = type('ResetSetJobDefinition');
export const RESET_SET_SERVICE_ACCOUNT_ACTION_TYPE = type('ResetSetServiceAccount');
export const UNLOAD_JOB_FAILURE_ACTION_TYPE = type('UnloadJobFailure');

export const LIST_DATABASES_FOR_ENVIRONMENT_ACTION_TYPE = apiType('ListDatabasesForEnvironment');

export const LIST_SNOWFLAKE_STAGES_ACTION_TYPE = apiType(LIST_SNOWFLAKE_STAGES);
export const GET_SNOWFLAKE_STAGE_DETAILS_ACTION_TYPE = apiType(GET_SNOWFLAKE_STAGE_DETAILS);
export const LIST_SNOWFLAKE_FILE_FORMATS_ACTION_TYPE = apiType(LIST_SNOWFLAKE_FILE_FORMATS);
export const LIST_SNOWFLAKE_STAGE_FILES_ACTION_TYPE = apiType(LIST_SNOWFLAKE_STAGE_FILES);
export const GET_SNOWFLAKE_STAGE_FILE_INFO_ACTION_TYPE = apiType(GET_SNOWFLAKE_STAGE_FILE_INFO);
export const CLEAR_SNOWFLAKE_STAGE_FILES_LIST_ACTION_TYPE = type('ClearSnowflakeStageFiles');

export const GET_MODEL_TAG_CHECK_CANDIDATES_ACTION_TYPE = apiType(GET_MODEL_TAG_CHECK_CANDIDATES);
export const CLEAR_MODEL_TAG_CHECK_CANDIDATES = type('ClearModelTagCheckCandidates');

export const GET_JOB_DEFINITION_ACTION_TYPE = apiType(GET_JOB_DEFINITION);

export const GET_MODEL_TAG_SOURCE_TABLES_ACTION_TYPE = apiType(GET_MODEL_TAG_SOURCE_TABLES);
export const CLEAR_MODEL_TAG_SOURCE_TABLES = type('ClearModelTagSourceTables');

export const SET_JOB_TRIGGER_CANDIDATES_FILTER = type('SetJobTriggerCandidatesFilter');
export const SET_JOB_DEFINITION_FILTER = type('SetJobDefinitionFilter');
